// src/components/MapControls.js
import React from 'react';
import { Box } from '@mui/material';
import PlacesSearch from './PlacesSearch';
import RecenterButton from './RecenterButton';

export default function MapControls({
    searchText,
    onSearchChange,
    onSelect,
    onRecenter,
    followMode,
    theme,
}) {
    return (
        <Box
            sx={{
                position: 'absolute',
                top: 16,
                left: 16,
                right: 16,
                display: 'flex',
                gap: 1,
                zIndex: 12,
            }}
        >
            <RecenterButton
                onClick={onRecenter}
                theme={theme}
                sx={{
                    backgroundColor: followMode
                        ? theme.palette.primary.main
                        : theme.palette.grey[300],
                    color: followMode
                        ? theme.palette.primary.contrastText
                        : theme.palette.text.secondary,
                    '&:hover': {
                        backgroundColor: followMode
                            ? theme.palette.primary.dark
                            : theme.palette.grey[400],
                    },
                }}
            />
            <PlacesSearch
                value={searchText}
                onChange={onSearchChange}
                onSelect={onSelect}
            />
        </Box>
    );
}
